export default __webpack_public_path__ + "static/media/USDC-croped.09323389.svg";